import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../constants/queryKeys";

export const useLoginWithFacebook = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.LOGIN_WITH_FACEBOOK],
    mutationFn: (): Promise<fb.AuthResponse | null> => {
      return new Promise((res) => {
        FB.login((facebookLoginResponse) => {
          if (facebookLoginResponse.authResponse) {
            queryClient.setQueriesData(
              { queryKey: [QUERY_KEYS.GET_FACEBOOK_LOGIN_STATUS] },
              () => facebookLoginResponse.authResponse,
            );
            void queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.GET_FACEBOOK_PROFILE],
            });
            return res(facebookLoginResponse.authResponse);
          } else {
            queryClient.setQueriesData(
              { queryKey: [QUERY_KEYS.GET_FACEBOOK_LOGIN_STATUS] },
              () => null,
            );
            queryClient.setQueriesData(
              { queryKey: [QUERY_KEYS.GET_FACEBOOK_PROFILE] },
              () => null,
            );

            return res(null);
          }
        });
      });
    },
  });
};
